import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=0c711e93"
import script from "./UserInput.vue?vue&type=script&lang=ts"
export * from "./UserInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports